module.exports = __webpack_public_path__ + "img/svg/sidebar-amount-separator.095a83e759dc740e2a752409ad975df9.svg";